import Button from './Button';

const IconButton = ({ icon: Icon, label, tooltip, variant = 'link-secondary', ...rest }) => (
  // A disabled button ignores its own title, so the tooltip lives on the wrapper.
  <span title={tooltip || label} className="inline-flex">
    <Button variant={variant} className="btn-icon avtar-s" aria-label={label} {...rest}>
      <Icon className="w-4 h-4" aria-hidden="true" />
    </Button>
  </span>
);

export default IconButton;
